<template>
	<AppDialog hideCloseButton disableMaxWidth :dialogName="'installationComplete'" width="820px">
		<div class="dialog-content rounded display-flex flex-row" :class="{ 'is-show': isMounted }">
			<div class="left-side display-flex flex-column flex-justify-space-between left width-100">
				<div class="mb-8">
					<div class="header-text bold">Who are you building features for?</div>
					<div class="flex-start--center flex-row">
						<AnemicButton
							class="large-button mr-5 loaded-6"
							:class="{ 'selected-btn': whoSelection === 'myself_option' }"
							@click="whoSelection = 'myself_option'"
						>
							<MyselfSvg />
							<div class="mt-2">Myself</div>
						</AnemicButton>
						<AnemicButton
							class="large-button loaded-7"
							:class="{ 'selected-btn': whoSelection === 'myteam_option' }"
							@click="whoSelection = 'myteam_option'"
						>
							<MyTeamSvg />
							<div class="mt-2">My team</div>
						</AnemicButton>
					</div>
				</div>
				<div class="mb-3">
					<div class="header-text">How did you hear about Ply?</div>
					<div class="">
						<div v-for="(btn, i) in buttonOptions" :key="i">
							<AnemicButton
								class="small-button"
								:class="{ 'selected-btn': btn.name === howSelection, [`loaded-${i + 2}`]: true }"
								@click="selectHow(btn.name)"
							>
								<component :is="btn.svgComponent" />
								<div>{{ btn.name }}</div>
							</AnemicButton>
						</div>
						<AnemicButton
							v-if="!isOtherButtonClicked"
							@click="otherButtonClicked"
							class="small-button loaded-9"
							:class="{ 'selected-btn': 'Other' === howSelection }"
						>
							<OtherSvg />
							<div>Other</div>
						</AnemicButton>
						<AppTextField v-else v-model="otherOptionInput" placeholder="Enter other option" outlined />
					</div>
				</div>
				<div class="display-flex flex-row flex-align-center">
					<AnemicButton @click="done" tile class="yes-button pa-0" :disabled="!whoSelection || !howSelection">Done</AnemicButton>
					<AnemicButton @click="skip" tile class="skip-button pa-0 ml-4">Skip</AnemicButton>
				</div>
			</div>
			<div class="right-side width-100 flex-centerize">
				<v-img :src="SideImage" />
			</div>
		</div>
	</AppDialog>
</template>

<script>
import { mapActions } from 'vuex';

import BlogPostSvg from './assets/BlogPostSvg';
import FacebookSvg from './assets/FacebookSvg';
import FriendOrColleagueSvg from './assets/FriendOrColleagueSvg';
import GoogleSearchSvg from './assets/GoogleSearchSvg';
import LinkedInSvg from './assets/LinkedInSvg';
import MyTeamSvg from './assets/MyTeamSvg';
import MyselfSvg from './assets/MyselfSvg';
import OtherSvg from './assets/OtherSvg';
import ProductHuntSvg from './assets/ProductHuntSvg';
import TwitterSvg from './assets/TwitterSvg';
import SideImage from './assets/side-image.png';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { userOnBoardingMetadata } from '@/store/modules/auth/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import AnalyticsService from '@/utils/AnalyticsService';

const getButtonOption = (name, svgComponent) => ({
	name,
	svgComponent,
});

export default {
	name: 'WelcomeToPlyDialog',
	components: {
		AppDialog,
		MyselfSvg,
		MyTeamSvg,
		OtherSvg,
	},
	props: {
		dialogPromiseHandlers: { type: Object },
	},
	data() {
		return {
			whoSelection: '',
			howSelection: '',
			buttonOptions: [
				getButtonOption('LinkedIn', LinkedInSvg),
				getButtonOption('Facebook', FacebookSvg),
				getButtonOption('Twitter', TwitterSvg),
				getButtonOption('Product Hunt', ProductHuntSvg),
				getButtonOption('Google search', GoogleSearchSvg),
				getButtonOption('Blog post', BlogPostSvg),
				getButtonOption('A friend or colleague', FriendOrColleagueSvg),
				// getButtonOption('Other', OtherSvg),
			],
			SideImage,
			isOtherButtonClicked: false,
			otherOptionInput: '',
			isMounted: false,
		};
	},
	computed: {
		...mapGettersShorthand({ userOnBoardingMetadata }),
	},
	methods: {
		...mapActions(['saveUserOnBoardingMetadata']),
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
		done() {
			const { whoSelection, howSelection, otherOptionInput } = this;
			const newUserProps = { user_building_for: whoSelection, user_heard_from: howSelection, other_option: otherOptionInput };
			AnalyticsService.updateUserProps(newUserProps);
			this.saveUserOnBoardingMetadata({ seenWelcomeToPlyDialog: true });
			this.close();
		},
		skip() {
			this.saveUserOnBoardingMetadata({ seenWelcomeToPlyDialog: true });
			this.close();
		},
		otherButtonClicked() {
			this.isOtherButtonClicked = true;
			this.howSelection = 'Other';
		},
		selectHow(btnName) {
			this.howSelection = btnName;
			this.isOtherButtonClicked = false;
		},
	},
	mounted() {
		this.isMounted = true;
	},
};
</script>

<style scoped lang="scss">
.dialog-content {
	background: var(--white);
	overflow: hidden;

	.left-side,
	.right-side {
		opacity: 0;

		::v-deep(.v-image) {
			opacity: 0;
			transform: translateX(40px);
		}
	}
	&.is-show {
		opacity: 1;
		transition: 0.4s;

		.left-side {
			transition: 1.8s;
			transition-delay: 0.5s;
			opacity: 1;
		}
		.right-side {
			transition: 0.8s;
			opacity: 1;

			::v-deep(.v-image) {
				opacity: 1;
				transform: translateX(0);
				transition: 1.5s;
			}
		}
		.small-button,
		.large-button {
			opacity: 1;
			transition: opacity 0.4s;
		}
	}
}

.rounded {
	border-radius: 10px !important;
}
.left {
	padding: 30px;
}
.right-side {
	width: 263px;
	background: #5354e7;
	border-top-right-radius: 10px;
	border-bottom-right-radius: 10px;
}
.header-text {
	margin-bottom: 20px;
	font-size: 16px;
	color: #262626;
	font-weight: 600;
}
.footer-button {
	width: 170px !important;
	height: 40px !important;
	font-size: 14px !important;
	border-radius: 8px !important;
	font-weight: normal !important;
	letter-spacing: 0px !important;
}
.yes-button {
	@extend .footer-button;
	color: #ffffff !important;
	background: #5858ec !important;
	height: 40px !important;
}

.large-button,
.small-button {
	background-color: transparent !important;
	box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.21) !important;
	border: 1px solid transparent;
	opacity: 0;
	transition: 0.2s;

	&:hover {
		background-color: #f4f7f8 !important;
		border: 1px solid #f4f7f8 !important;
		transition: 0.3s;

		&:before {
			display: none;
		}
	}
	&.selected-btn {
		background-color: #f4f7f8 !important;
		box-shadow: none !important;
		border: 1px solid #e1e5ec !important;
	}
}
.large-button {
	padding: 45px 66px !important;

	::v-deep(.v-btn__content) {
		display: flex;
		flex-direction: column;
		font-size: 14px !important;
	}
}
.small-button {
	justify-content: start !important;
	width: 100%;
	padding: 4px 0 !important;
	margin-bottom: 10px;
	font-size: 14px !important;

	::v-deep(.v-btn__content) {
		svg {
			margin: 0 14px;
		}
	}
}
.skip-button {
	@extend .footer-button;
	height: 40px !important;
	color: #5858ec !important;
	background: #ffffff !important;
	border: 1px solid #5858ec !important;
}
</style>
